import { Howl } from "howler"

import {observable,  makeObservable, makeAutoObservable } from "mobx"
import { pickRandom } from "./utils"

class Sound {
  constructor(json) {
    Object.assign(this, json)
    makeAutoObservable(this)
  }
}

class SoundPlayer {

  all = []

  _mute = false
  _sfxMute = false
  _musicMute = false

  previousId = null
  currentId = null

  /**
   * Durée de fade in/out lors d'un changement de musique (en millisecondes)
   */
  musicFadeDuration = 1000


  constructor() {
    // 2 players : un pour la msique, un pour le son (comme ca les sons peuvent être joués en meme tps que la zik)

    /** @type <Howl> */
    this.musicPlayer = null

    makeObservable(this, {
      _mute: observable,
      _sfxMute: observable,
      _musicMute: observable
    })
  }

  init(json) {
    this.all = json
    .filter(elem => elem.id).map(elem => new Sound(elem))
  }

  get ids() { return this.all.map(c => c.id)}

  mute(val) {
    console.log("SoundPlayer mute", val);

    if(typeof val === "boolean") {
      this._mute = val
      if(this.musicPlayer)
        this.musicPlayer.mute(val)
    }
    else if(this.musicPlayer) { 
      // ??
      this.prevVolume = this.musicPlayer.volume()
      this.musicPlayer.volume(val)
    }
  }
  unmute() {

    if(this.prevVolume && this.musicPlayer) {
      console.log("unmute");
      this.musicPlayer.volume(this.prevVolume)

    }
  }

  muteSfx(muteStatus) {
    console.log("SoundPlayer muteSfx", muteStatus);
    this._sfxMute = muteStatus
  }
  muteMusic(muteStatus) {
    console.log("SoundPlayer muteMusic", muteStatus);
    this._musicMute = muteStatus
    if (this.musicPlayer) {
      this.musicPlayer.mute(muteStatus)
    }
  }

  get(id) { return this.all.find(c => c.id === id) }


  playSound(id, callback = null) {

    let s = this.get(id)
    if(!s) return

    if(s.type === "musicRandom") {
      let _id = pickRandom(s.path.split('|'))
      this.playSound(_id)
      return
    }



    if(s.type === "music") {
      console.log("playSound music", id, s.volume);

      if(this.currentId === id) return
      if(this.musicPlayer) {
        if(this.currentId) this.previousId = this.currentId
        this.#fadeOutMusic(this.musicPlayer)
      }

      this.currentId = id
      // console.log("playing music", id)
      let src = [`${s.path}.mp3`, `${s.path}.ogg`]

      this.musicPlayer = new Howl({
        src: src,
        autoplay: true,
        loop: true,
        volume: 0,
        mute: this._mute || this._musicMute
      })

      this.musicPlayer.fade(0, s.volume === null ? 1 : s.volume, this.musicFadeDuration)
    }

    if(s.type === "sfx") {
      console.log("playSound sfx", id);
      // console.log("playing sound", id)
      let src = [`${s.path}.mp3`, `${s.path}.ogg`]
      new Howl({
        src: src,
        autoplay: true,
        loop: false,
        volume: s.volume || 1,
        onend: callback,
        mute: this._mute || this._sfxMute
      })

    }

  }

  #fadeOutMusic(player) {
    player.onfade = () => {
      player.stop()
      player.unload()
    }
    player.fade(player.volume(), 0, this.musicFadeDuration)
  }

  playPreviousMusic () {
    if(this.previousId) {
      this.playSound(this.previousId)
    }
  }

  stop() {
    if(this.musicPlayer) {
      this.musicPlayer.stop()
      this.musicPlayer.unload()
      this.musicPlayer = null
      this.previousId = this.currentId
      this.currentId = null
    }
  }

  pause() {
    if(this.musicPlayer) this.musicPlayer.pause()

  }
  unpause() {
    if(this.musicPlayer) this.musicPlayer.play()

  }
}


export default new SoundPlayer()
